import React from "react";
import {longColour, shortColour} from "../../style/styleConsts";

const IdeaCounts = ({style, openIdeas, inverted, allIdeaCounts = false}) => (
    <div style={style}>
        <Count className="t-longs" style={{color: inverted ?  "white" : longColour}} count={openIdeas.longs}   suffix="L" allIdeaCounts={allIdeaCounts}/>
        <Count className="t-shorts" style={{color: inverted ? "white" : shortColour}} count={openIdeas.shorts}  suffix="S" allIdeaCounts={allIdeaCounts}/>
    </div>
);

const Count = ({count, suffix, className, allIdeaCounts, style}) => {
    const content = (count > 0) ? `${count}${suffix}` : "";
    return <div className={className} style={{...style, float: "left", width: allIdeaCounts ? 38 : 28, minHeight: "1px", marginRight: 3}}>{content}</div>
};

export default IdeaCounts;
